import getAvailabilityByRegion from "@utils/getAvailabilityByRegion"
import React from "react"

type Args = {
  currentSku?: string
  currentVariant?: {
    availability?: "Sell Everywhere" | "Sell in INTL" | "Sell in US" | undefined
  } | null
  customerCountryCode?: string
  inventoryData: null | Record<string, any>
  mode: Mode
}

type AvailabilityData = {
  isAvailable: boolean
  quantity: number
  shippingMessage?: string
  warehouseLocation?: string
}

type Mode = "PDP" | "SOPDP"

export function usePdpAvailability({
  currentSku,
  currentVariant,
  customerCountryCode,
  inventoryData,
  mode,
}: Args) {
  const [availabilityData, setAvailabilityData] =
    React.useState<AvailabilityData>({
      isAvailable: false,
      quantity: 0,
      shippingMessage: "",
      warehouseLocation: "",
    })

  React.useEffect(() => {
    if (!currentSku || !inventoryData) return
    const data = getAvailabilityByRegion(
      customerCountryCode || "US",
      currentSku,
      inventoryData,
      {
        mode,
        variantAvailability: currentVariant?.availability,
      }
    )
    setAvailabilityData(data)
  }, [
    mode,
    currentSku,
    customerCountryCode,
    currentVariant?.availability,
    inventoryData,
  ])

  return {
    availabilityData,
    shippingMessage: availabilityData?.shippingMessage,
  }
}
